import { Contact } from '../contact/contact';
import { Groups } from './groups';

export class GroupsMembers {
  public id: number;
  public groupe: Groups;
  public contact: Partial<Contact>;

  constructor(data: Partial<GroupsMembers>) {
    Object.assign(this, data);
  }
}
